import classNames from 'classnames/bind';
import styles from './CustomLink.module.css';

export default function CustomLink({
  url,
  target = '_blank',
  classList,
}: {
  url: string;
  target?: string;
  classList?: string[];
}) {
  const cx = classNames.bind(styles);

  return (
    <a
      href={url.startsWith('http') ? url : `https://${url}`}
      className={cx(classList)}
      target={target}
      rel="noopener noreferrer"
    >
      {url}
    </a>
  );
}
